<template>
  <div ref="timeslot" class="timeslot">
    <vue-timepicker
      ref="timepicker"
      :key="timeslotKey"
      v-model="startTime"
      format="HH:mm"
      auto-scroll
      hide-disabled-items
      placeholder=" "
      :hour-range="[ [ 8, 19 ] ]"
      :minute-interval="15"
      close-on-complete
      hide-clear-button
      :name="name"
      class="input-text"
      @change="onChange"
    />
    <div v-show="interval" class="interval">
      <span>{{ interval }}</span>
    </div>
  </div>
</template>

<script>
import VueTimepicker from 'vue3-timepicker';
import moment from 'moment';

export default {
  components: {
    VueTimepicker,
  },
  props: {
    name: { type: String, default: 'time' },
    initialTime: { type: Object, default: () => {} },
  },
  data() {
    return {
      startTime: {
        HH: null,
        mm: null,
      },
      timeslotKey: 0,
    };
  },
  computed: {
    interval() {
      if (!this.startTime.HH || !this.startTime.mm) {
        return null;
      }

      const time = moment(`${this.startTime.HH}:${this.startTime.mm}`, 'HH:mm');
      return `${time.format('HH:mm')}-${time.add(30, 'minutes').format('HH:mm')}`;
    },
  },
  watch: {
    initialTime(value) {
      if (!value || (value.HH === '' && value.mm === '')) {
        this.timeslotKey++;
      }
    },
  },
  methods: {
    onChange(value) {
      this.$emit('time-changed', value.data);
    },
  },
};
</script>
